__turbopack_context__.v({
  "btnPrimary": "RedesignHome-module__OANqDa__btnPrimary",
  "btnSecondary": "RedesignHome-module__OANqDa__btnSecondary",
  "ctaActions": "RedesignHome-module__OANqDa__ctaActions",
  "ctaSection": "RedesignHome-module__OANqDa__ctaSection",
  "ctaStore": "RedesignHome-module__OANqDa__ctaStore",
  "eyebrowDot": "RedesignHome-module__OANqDa__eyebrowDot",
  "featureCard": "RedesignHome-module__OANqDa__featureCard",
  "featureDesc": "RedesignHome-module__OANqDa__featureDesc",
  "featureIcon": "RedesignHome-module__OANqDa__featureIcon",
  "featureTitle": "RedesignHome-module__OANqDa__featureTitle",
  "featuresGrid": "RedesignHome-module__OANqDa__featuresGrid",
  "float": "RedesignHome-module__OANqDa__float",
  "footer": "RedesignHome-module__OANqDa__footer",
  "footerCopy": "RedesignHome-module__OANqDa__footerCopy",
  "footerLinks": "RedesignHome-module__OANqDa__footerLinks",
  "footerLogo": "RedesignHome-module__OANqDa__footerLogo",
  "govBenefit": "RedesignHome-module__OANqDa__govBenefit",
  "govBenefitCheck": "RedesignHome-module__OANqDa__govBenefitCheck",
  "govBenefitDesc": "RedesignHome-module__OANqDa__govBenefitDesc",
  "govBenefitTitle": "RedesignHome-module__OANqDa__govBenefitTitle",
  "govBenefits": "RedesignHome-module__OANqDa__govBenefits",
  "govGrid": "RedesignHome-module__OANqDa__govGrid",
  "govStep": "RedesignHome-module__OANqDa__govStep",
  "govStepNum": "RedesignHome-module__OANqDa__govStepNum",
  "govStepText": "RedesignHome-module__OANqDa__govStepText",
  "govSteps": "RedesignHome-module__OANqDa__govSteps",
  "govVisual": "RedesignHome-module__OANqDa__govVisual",
  "govVisualTitle": "RedesignHome-module__OANqDa__govVisualTitle",
  "hero": "RedesignHome-module__OANqDa__hero",
  "heroActions": "RedesignHome-module__OANqDa__heroActions",
  "heroEyebrow": "RedesignHome-module__OANqDa__heroEyebrow",
  "heroH1": "RedesignHome-module__OANqDa__heroH1",
  "heroSub": "RedesignHome-module__OANqDa__heroSub",
  "heroVisual": "RedesignHome-module__OANqDa__heroVisual",
  "phone": "RedesignHome-module__OANqDa__phone",
  "phoneBell": "RedesignHome-module__OANqDa__phoneBell",
  "phoneCard": "RedesignHome-module__OANqDa__phoneCard",
  "phoneCardLabel": "RedesignHome-module__OANqDa__phoneCardLabel",
  "phoneCardTitle": "RedesignHome-module__OANqDa__phoneCardTitle",
  "phoneHeader": "RedesignHome-module__OANqDa__phoneHeader",
  "phoneLogo": "RedesignHome-module__OANqDa__phoneLogo",
  "phoneNotch": "RedesignHome-module__OANqDa__phoneNotch",
  "phoneScreen": "RedesignHome-module__OANqDa__phoneScreen",
  "phoneStat": "RedesignHome-module__OANqDa__phoneStat",
  "phoneStatLbl": "RedesignHome-module__OANqDa__phoneStatLbl",
  "phoneStatNum": "RedesignHome-module__OANqDa__phoneStatNum",
  "phoneStatRow": "RedesignHome-module__OANqDa__phoneStatRow",
  "phoneTag": "RedesignHome-module__OANqDa__phoneTag",
  "phoneWrap": "RedesignHome-module__OANqDa__phoneWrap",
  "pulse": "RedesignHome-module__OANqDa__pulse",
  "pulseRing": "RedesignHome-module__OANqDa__pulseRing",
  "section": "RedesignHome-module__OANqDa__section",
  "sectionLabel": "RedesignHome-module__OANqDa__sectionLabel",
  "sectionSub": "RedesignHome-module__OANqDa__sectionSub",
  "sectionTitle": "RedesignHome-module__OANqDa__sectionTitle",
  "settlementAdd": "RedesignHome-module__OANqDa__settlementAdd",
  "settlementAddIcon": "RedesignHome-module__OANqDa__settlementAddIcon",
  "settlementCard": "RedesignHome-module__OANqDa__settlementCard",
  "settlementIcon": "RedesignHome-module__OANqDa__settlementIcon",
  "settlementName": "RedesignHome-module__OANqDa__settlementName",
  "settlementsGrid": "RedesignHome-module__OANqDa__settlementsGrid",
  "settlementsSection": "RedesignHome-module__OANqDa__settlementsSection",
  "site": "RedesignHome-module__OANqDa__site",
  "statItem": "RedesignHome-module__OANqDa__statItem",
  "statLabel": "RedesignHome-module__OANqDa__statLabel",
  "statNum": "RedesignHome-module__OANqDa__statNum",
  "statsGrid": "RedesignHome-module__OANqDa__statsGrid",
  "statsSection": "RedesignHome-module__OANqDa__statsSection",
  "storeBadge": "RedesignHome-module__OANqDa__storeBadge",
  "storeBadges": "RedesignHome-module__OANqDa__storeBadges",
  "trustBar": "RedesignHome-module__OANqDa__trustBar",
  "trustDot": "RedesignHome-module__OANqDa__trustDot",
  "trustItem": "RedesignHome-module__OANqDa__trustItem",
  "trustItems": "RedesignHome-module__OANqDa__trustItems",
  "trustLabel": "RedesignHome-module__OANqDa__trustLabel",
});
